export const site = {
  brand: 'BISEN',
  kicker: 'Proposed retail kiosk · KCC Mall',
  headline: 'Everyday mobile essentials, within easy reach.',
  subhead:
    'BISEN is a proposed cellphone accessories kiosk for KCC Mall, offering practical products through a bright, organized and easy-to-shop retail format.',
  proposalLine: 'Proposed BISEN cellphone accessories kiosk · KCC Mall',
  applicant: 'BISEN Retail Concept',
  phone: '+63 9XX XXX XXXX',
  email: 'hello@bisen.ph',
  location: 'Cotabato City, Philippines',
}

export const navItems = [
  { label: 'Intent', href: '#intent' },
  { label: 'Concept', href: '#concept' },
  { label: 'Products', href: '#products' },
  { label: 'Store', href: '#store' },
  { label: 'Why KCC', href: '#fit' },
]

export const intent = {
  to: 'The Leasing Department',
  subject: 'Letter of Intent — BISEN Cellphone Accessories Kiosk',
  preview:
    'BISEN respectfully expresses its intent to establish a cellphone accessories kiosk within KCC Mall and to comply with the mall’s leasing, design, operational and documentary requirements.',
  paragraphs: [
    'The proposed kiosk will offer commonly needed mobile accessories, including protective cases, chargers, cables, audio accessories, screen protection, power banks and other practical cellphone essentials.',
    'The retail concept is intended to be compact, visible and easy to navigate, with clear merchandising and an organized product display suited to regular mall traffic and quick customer transactions.',
    'We would welcome the opportunity to discuss the proposal further, present the store concept in detail and submit the final documents required for evaluation.',
  ],
}

export const products = [
  {
    id: '01',
    key: 'cases',
    name: 'Phone cases',
    statement: 'Protection and everyday style for a range of devices.',
    detail: 'A visible assortment of practical case options that customers can compare quickly at the kiosk.',
  },
  {
    id: '02',
    key: 'chargers',
    name: 'Chargers',
    statement: 'Charging essentials for common day-to-day needs.',
    detail: 'Wall chargers and compact adapters presented by use case and connector compatibility.',
  },
  {
    id: '03',
    key: 'cables',
    name: 'Cables',
    statement: 'Common connector types kept easy to identify and replace.',
    detail: 'Everyday charging and data cables organized so customers can find the right type without a long buying process.',
  },
  {
    id: '04',
    key: 'glass',
    name: 'Screen protection',
    statement: 'Simple protection for one of the phone’s most exposed parts.',
    detail: 'Tempered glass and related screen-protection products positioned as a convenient add-on purchase.',
  },
  {
    id: '05',
    key: 'audio',
    name: 'Audio accessories',
    statement: 'Practical options for calls, music, school and work.',
    detail: 'Wired and wireless audio essentials selected for customers who need a quick replacement or upgrade.',
  },
  {
    id: '06',
    key: 'powerbanks',
    name: 'Power banks',
    statement: 'Portable backup power for customers on the move.',
    detail: 'Compact power options for commuters, students, travelers and other shoppers who need extra battery life.',
  },
] as const

export const conceptPoints = [
  { number: '01', title: 'Visible', body: 'A clear kiosk presence that can be recognized from normal mall walking paths.' },
  { number: '02', title: 'Organized', body: 'Products grouped and displayed in a way that makes comparison straightforward.' },
  { number: '03', title: 'Practical', body: 'A focused assortment built around frequent cellphone-accessory needs.' },
  { number: '04', title: 'Compact', body: 'A kiosk format that uses retail space efficiently without feeling crowded.' },
]

export const storeDetails = [
  {
    number: '01',
    title: 'Open sightlines',
    body: 'The kiosk remains visible and approachable from more than one direction.',
  },
  {
    number: '02',
    title: 'Clear merchandising',
    body: 'A broad product assortment is grouped so the display stays readable rather than chaotic.',
  },
  {
    number: '03',
    title: 'Recognizable identity',
    body: 'BISEN green is used consistently to make the kiosk easy to identify on the mall floor.',
  },
]

export const fitReasons = [
  {
    number: '01',
    title: 'Frequent-purchase category',
    body: 'Cases, cables, chargers and screen protection address common needs that can lead to both planned and impulse purchases.',
  },
  {
    number: '02',
    title: 'Broad customer appeal',
    body: 'The category serves students, professionals, families, travelers and other regular mall visitors.',
  },
  {
    number: '03',
    title: 'Space-efficient format',
    body: 'A kiosk can carry a varied assortment while using a relatively compact retail footprint.',
  },
  {
    number: '04',
    title: 'Quick transactions',
    body: 'Clear product grouping supports short, uncomplicated purchases for customers who already know what they need.',
  },
  {
    number: '05',
    title: 'Mall-appropriate presentation',
    body: 'The proposed look prioritizes cleanliness, lighting, visibility and an organized customer-facing display.',
  },
]
